import React, { Component, useState } from 'react';
import { connect } from 'react-redux'
import { Modal, Carousel } from 'antd'

import { actionCreators } from '../../store'
import styles from './index.module.css'
import arrowImg from '../../../../statics/update_done_butn_arrow_forward.png'
import bgImg from '../../../../statics/update_info_bg.png'
import MyButton from '../../../../common/MyButton';


function MyCarousel({ items, handleDone }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const carouselRef = React.useRef();

    const goToNext = () => {
        console.log("next");
        carouselRef.current.next();
    };

    return (
        <>
            <div className={styles.carousel_container}>
                <Carousel
                    // arrows
                    infinite={false}
                    // fade={true}
                    speed={300}
                    ref={carouselRef}
                    afterChange={(current) => {setCurrentSlide(current); console.log("after current = ", current);}}
                    dots={items.length > 1 ? true : false}
                >
                    {
                        items.map((item) => {
                            return (
                                <div className={styles.carousel_item} key={item}>
                                    <img src={item} className={styles.bg_img} />
                                </div>
                            )
                        })
                    }
                </Carousel>
            </div>

            <div className={styles.footer}>
                <div className={styles.done_butn_box}>
                    {
                        currentSlide + 1 === items.length ? (
                            <MyButton
                                width={'240px'}
                                height={'40px'}
                                onClick={handleDone}
                                text={<><span>开始我的灵石之旅</span></>}
                                type="primary"
                            />
                        ) : (
                            <MyButton
                                width={'240px'}
                                height={'40px'}
                                onClick={goToNext}
                                text={<><span>下一页</span><img src={arrowImg} /></>}
                                type="primary"
                            />
                        )
                    }
                </div>
            </div>
        </>
    );
}

class VersionUpdateImageModal extends Component {
    render() {
        let version_update_list = this.props.version_update_list.toJS()
        let show_version_update_image_id = this.props.show_version_update_image_id
        let obj = version_update_list.find(item => item.id === show_version_update_image_id) || {}

        return (
            <Modal
                open={this.props.is_show_version_update_image}
                onOk={this.handleDone.bind(this)}
                onCancel={this.handleDone.bind(this)}
                footer={null}
                width={1139}
                height={775}
                className={styles.modal_container}
            >
                <div className={styles.main}>
                    <MyCarousel
                        items={obj?.meta_data?.images || []}
                        handleDone={this.handleDone.bind(this)}
                    />
                </div>
          </Modal>
        )
    }

    handleDone() {
        console.log("done");
        this.props.handleIsShowVersionUpdateImage(false)
        this.props.handleShowVersionUpdateImageId('')
    }
}

const mapStateToProps = (state) => {
    return {
        is_show_version_update_image: state.get('admin').get('is_show_version_update_image'),
        version_update_list: state.get('admin').get('version_update_list'),
        show_version_update_image_id: state.get('admin').get('show_version_update_image_id'),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleIsShowVersionUpdateImage(status) {
            dispatch(actionCreators.isShowVersionUpdateImage(status))
        },
        handleShowVersionUpdateImageId(value) {
            dispatch(actionCreators.showVersionUpdateImageId(value))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VersionUpdateImageModal)